document.addEventListener('click', function(event) {
  var openButton = event.target.closest('[data-open-header-contact-popup]');
  var closeButton = event.target.closest('[data-close-header-contact-popup]');
  var popup = document.getElementById('header-contact-popup');

  if (!popup) return;

  if (openButton) {
    event.preventDefault();
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('header-contact-popup-open');

    var closeEl = popup.querySelector('.header-contact-popup__close');
    if (closeEl) closeEl.focus();
  }

  if (closeButton) {
    event.preventDefault();
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('header-contact-popup-open');
  }
});

document.addEventListener('keydown', function(event) {
  var popup = document.getElementById('header-contact-popup');
  if (!popup) return;

  if (event.key === 'Escape' && popup.classList.contains('is-open')) {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('header-contact-popup-open');
  }
});